export class UserPermissionView
{
  public permissionId : number = 0;
  public permissionKeyCode : string = '';

  public screenId : number = 0;
  public screenKeyCode : string = '';
}
